import React, { useState, useEffect } from "react";
import { apiRouterCall } from "../api/services";

export default function usePaymentOptions({ module }) {
  const [paymentOptions, setPaymentOptions] = useState([]);

  //function to fetch the module lists
  const getModuleLIstHandler = async () => {
    try {
      const response = await apiRouterCall({
        method: "GET",
        endPoint: "moduleList",
      });
      if (response.data.responseCode === 200) {
        const moduleId = response?.data?.result?.find(
          (data, i) => data?.moduleName === module
        );
        if (moduleId) {
          getPaymentOptionsHandler(moduleId?._id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //function to fetch the payment options
  const getPaymentOptionsHandler = async (id) => {
    try {
      const response = await apiRouterCall({
        method: "GET",
        endPoint: "paymentCoinList",
        params: {
          moduleId: id,
        },
      });

      if (response.data.responseCode === 200) {
        const availableOptions = response?.data?.result.filter((x) => {
          return x.isActive && x.status !== "DELETE";
        });
        setPaymentOptions(availableOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getModuleLIstHandler();
    return () => {};
  }, []);

  return paymentOptions;
}
